import React from 'react';

export const TutorialApp: React.FC = () => (
  <div className="w-full pt-10 pb-28 px-5 md:px-20 text-neutro-b-400">
    <div className="flex flex-col items-start gap-6">
      <h1 className="text-2xl font-bold">
        Seu ingresso está disponível no <span className="text-red-400">APP Banca do Ingresso.</span>
      </h1>

      <p className="text-base">Baixe o app, acesse sua conta e curta o evento sem preocupações!</p>

      <div className="flex gap-4 mt-4">
        <a
          href="https://play.google.com/store/apps/details?id=br.com.bancadoingresso.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://bdi-image-email.s3.amazonaws.com/google_play_2.png"
            alt="Google Play"
            width="158"
            height="50"
            className="cursor-pointer"
          />
        </a>
        <a
          href="https://apps.apple.com/br/app/banca-do-ingresso/id6448055016"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://bdi-image-email.s3.amazonaws.com/app-store2.png"
            alt="App Store"
            width="158"
            height="50"
            className="cursor-pointer"
          />
        </a>
      </div>

      <div className="mt-12">
        <h2 className="text-lg font-semibold mb-5">Como acessar seu ingresso:</h2>
        <ol className="list-decimal list-inside space-y-3 text-base text-neutro-b-500">
          <li>
            Acesse o app <strong>Banca do Ingresso</strong>.
          </li>
          <li>
            Entre na aba <strong>Ingressos</strong>.
          </li>
          <li>
            Selecione o evento e clique em <strong>Visualizar Ingresso</strong>.
          </li>
          <li>Aproveite seu evento! 🎉</li>
        </ol>
      </div>
    </div>
  </div>
);
//   <>
//     <div className="cart-content relative w-full pt-[30px] pb-[120px] px-5 md:px-[85px]">
//       <div className="flex flex-wrap justify-between items-left">
//         <h5 className="text-[23px] font-bold leading-[28px] text-neutro-b-400">
//           Seu ingresso estará disponível no nosso app <span className="text-red-400"> 24hs </span>{' '}
//           antes do evento para visualização.
//         </h5>
//       </div>
//       <hr className="mt-[20px]" />
//       <div>
//         <h5 className="text-[17px] font-normal leading-[28px] text-neutro-b-400 mt-[20px] text-left">
//           Para visualizar é bem simple, é só seguir o passo à passo:
//         </h5>
//       </div>
//       <div>
//         <h5 className="text-[15px] font-bold  leading-[28px] text-neutro-b-400 mt-[45px] text-left">
//           1 - Acesse a loja de aplicativo do seu celular e baixe o App Banca do ingresso;
//         </h5>
//         <div className="flex mt-[10px] items-center">
//           <a href="https://play.google.com/store/apps/details?id=br.com.bancadoingresso.app">
//             <img
//               data-imagetype="External"
//               src="https://bdi-image-email.s3.amazonaws.com/google_play_2.png"
//               alt=""
//               width="158px"
//               height="50px"
//               className="pl-[15px] cursor-pointer"
//             />
//           </a>
//           <a href="https://apps.apple.com/br/app/banca-do-ingresso/id6448055016">
//             <img
//               data-imagetype="External"
//               src="https://bdi-image-email.s3.amazonaws.com/app-store2.png"
//               alt=""
//               width="158px"
//               height="50px"
//               className="pl-[15px] cursor-pointer"
//             />
//           </a>
//         </div>
//       </div>
//       <div>
//         <h5 className="text-[15px] font-bold leading-[28px] text-neutro-b-400 mt-[45px] text-left">
//           2 - Clique na aba Ingressos;
//         </h5>
//         <div className="flex mt-[10px] items-center">
//           <img
//             data-imagetype="External"
//             src="https://bdi-image-email.s3.amazonaws.com/aba-app.jpg"
//             alt=""
//             width="414px"
//             height="60px"
//             className="pl-[15px]"
//           />
//         </div>
//       </div>
//       <div>
//         <h5 className="text-[15px] font-bold leading-[28px] text-neutro-b-400 mt-[45px] text-left">
//           3 - Selecione o evento e clique em Ingressos Disponíveis;
//         </h5>
//         <div className="flex mt-[10px] items-center">
//           <img
//             data-imagetype="External"
//             src="https://bdi-image-email.s3.amazonaws.com/painel_ticket.jpg"
//             alt=""
//             width="346px"
//             height="398px"
//             className="pl-[15px]"
//           />
//         </div>
//       </div>
//       <div>
//         <h5 className="text-[15px] font-bold leading-[28px] text-neutro-b-400 mt-[45px] text-left">
//           {'4 - Clique na opção "Clique aqui para visualizar"'};
//         </h5>
//         <div className="flex mt-[10px] items-center">
//           <img
//             data-imagetype="External"
//             src="https://bdi-image-email.s3.amazonaws.com/click-to-show.png"
//             alt=""
//             width="352px"
//             height="59px"
//             className="pl-[15px]"
//           />
//         </div>
//       </div>
//       <div>
//         <h5 className="text-[15px] font-bold leading-[28px] text-neutro-b-400 mt-[45px] text-left">
//           5 - Pronto! Agora é só aproveitar o seu evento;
//         </h5>
//       </div>
//     </div>
//   </>
